module.exports = __webpack_public_path__ + "img/beauty_smoohing.d181df4.svg";